import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Connect from './views/Connect.vue';
import Login from './views/Login.vue';
import NotFound from './views/NotFound.vue';
import ForgetPassword from './views/ForgetPassword';
import RenewPassword from './views/RenewPassword';
import Register from './views/Register';
import Transfer from './views/Transfer';
import Product from './views/Product';
import store from './store';
import tokenStore from './stores/token';

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/:lang?',
      beforeEnter: (to, from, next) => {
        if (to.params.lang === undefined || to.params.lang === 'en') {
          next();
        } else {
          next(error);
        }
      },
      component: {
        render(c) {
          return c('router-view');
        },
      },
      children: [
        {
          path: 'login',
          name: 'login',
          component: Login,
          meta: {
            title: 'Mükellef | Giriş Yap | Şirketinizi Kurun, Yönetin ve Büyütün',
          },
        },
        {
          path: '/connect',
          name: 'connect',
          component: Connect,
          meta: {
            title: 'Mükellef | Kayıt | Şirketinizi Kurun, Yönetin ve Büyütün',
            metaTags: [
              {
                name: 'description',
                content: 'Mükellef | Şirketinizi Kurun, Yönetin ve Büyütün',
              },
              {
                property: 'og:description',
                content: 'Mükellef | Şirketinizi Kurun, Yönetin ve Büyütün',
              },
            ],
          },
          beforeEnter: (to, from, next) => {
            if (location.hostname.includes('workhy') || process.env.NODE_ENV !== 'production') {
              next();
            } else {
              next({ name: 'login' });
            }
          },
        },
        {
          path: 'forgot-password',
          name: 'forgot-password',
          component: ForgetPassword,
          meta: {
            title: 'Mükellef | Şifremi Unuttum | Şirketinizi Kurun, Yönetin ve Büyütün',
          },
        },
        {
          path: 'renew-password',
          name: 'renew-password',
          component: RenewPassword,
          meta: {
            title: 'Mükellef | Şifre Yenile | Şirketinizi Kurun, Yönetin ve Büyütün',
          },
        },
        {
          path: 'register/:type?',
          name: 'register',
          component: Register,
          meta: {
            title: 'Mükellef | Şirket Kayıt | Şirketinizi Kurun, Yönetin ve Büyütün',
          },
          beforeEnter: (to, from, next) => {
            const types = ['us', 'uk'];
            if (
              (to.params.type === undefined && location.hostname.includes('workhy') === false) ||
              types.includes(to.params.type)
            ) {
              next();
            } else {
              next({ name: 'login' });
            }
          },
        },
        {
          path: 'transfer/:type?',
          name: 'register',
          component: Transfer,
          meta: {
            title: 'Mükellef | Şirket Kayıt | Şirketinizi Kurun, Yönetin ve Büyütün',
          },
          beforeEnter: (to, from, next) => {
            const types = ['us', 'uk'];
            if (types.includes(to.params.type)) {
              next();
            } else {
              next({ name: 'login' });
            }
          },
        },
        {
          path: 'product/:type?',
          name: 'register',
          component: Product,
          meta: {
            title: 'Mükellef | Şirket Kayıt | Şirketinizi Kurun, Yönetin ve Büyütün',
          },
          beforeEnter: (to, from, next) => {
            if (to.params.type === undefined && location.hostname.includes('workhy') === false) {
              next();
            } else {
              next({ name: 'login' });
            }
          },
        },
        {
          path: '/',
          name: 'home',
          component: Home,
          meta: {
            title: 'Mükellef | Kayıt | Şirketinizi Kurun, Yönetin ve Büyütün',
            metaTags: [
              {
                name: 'description',
                content: 'Mükellef | Şirketinizi Kurun, Yönetin ve Büyütün',
              },
              {
                property: 'og:description',
                content: 'Mükellef | Şirketinizi Kurun, Yönetin ve Büyütün',
              },
            ],
          },
        },
        // Not found
        {
          path: '*',
          component: NotFound,
          title: 'Sayfa bulunamadı',
          meta: {
            title: 'Mükellef | Sayfa Bulunamadı | Şirketinizi Kurun, Yönetin ve Büyütün',
          },
        },
      ],
    },
  ],
});

Vue.use(Router);
router.beforeEach(async (to, from, next) => {
  if (to.query.companyId && to.query.companyId !== 'newuser') {
    await window.$axios
      .get('/tenant/change/company/' + to.query.companyId)
      .then((s) => {
        tokenStore.commit('setOnlyAccessToken', s.data.token);
        const query = Object.assign({}, to.query);
        delete query.companyId;
        router.replace({ path: this.$route.path, query: query });
        // store.commit('setAccessToken', s.data);
      })
      .finally((s) => {
        next();
      });
  } else {
    if (to.query.t) {
      const redirectPaths = ['/register', '/product', '/transfer'];
      const isRedirectPath = redirectPaths.some((path) => to.path.includes(path));

      if (isRedirectPath) {
        let country = null;
        let currentPath = null;
        redirectPaths.forEach((path) => {
          if (to.path.includes(path)) {
            currentPath = path;
            const parts = to.path.split(path + '/');
            if (parts.length > 1) {
              country = parts[1];
            }
          }
        });

        if (!country) country = 'tr';
        const step = to.query.step || '1';
        const isNewCompany = to.query.companyId === 'newuser';
        const isMobile = to.query.device === 'mobile';

        let mainDashboardUrl;
        if (document.domain.includes('workhy') !== true) {
          mainDashboardUrl = process.env.VUE_APP_MUKELLEF_DASHBOARD_URL;
        } else {
          mainDashboardUrl = process.env.VUE_APP_WORKHY_DASHBOARD_URL;
        }

        const endpoint = currentPath === '/register' ? 'new-company' : 'new-transfer';
        let redirectUrl = mainDashboardUrl + endpoint + '/' + country + '/' + step;
        const queryParams = [];

        if (isNewCompany) {
          queryParams.push('isNewUser=true');
        }
        if (isMobile) {
          queryParams.push('device=mobile');
        }
        if (to.query.t) {
          queryParams.push('t=' + encodeURIComponent(to.query.t));
        }

        if (queryParams.length > 0) {
          redirectUrl += '?' + queryParams.join('&');
        }

        window.location.replace(redirectUrl);
        return;
      }
      const token = JSON.parse(atob(to.query.t));
      tokenStore.commit('setAccessToken', token);
      if (to.query.redirect === 'true') {
        let mainDashboardUrl;

        if (document.domain.includes('workhy') !== true) {
          mainDashboardUrl = process.env.VUE_APP_MUKELLEF_DASHBOARD_URL;
        } else {
          mainDashboardUrl = process.env.VUE_APP_WORKHY_DASHBOARD_URL;
        }

        if (to.query['new-company-nation-id']) {
          window.location.href =
            mainDashboardUrl +
            'create-new-company?new-company-nation-id=' +
            encodeURIComponent(to.query['new-company-nation-id']) +
            '&t=' +
            encodeURIComponent(to.query.t);
        } else {
          window.location.href = mainDashboardUrl + '?t=' + encodeURIComponent(to.query.t);
        }
        return;
      }
      const query = Object.assign({}, to.query);
      delete query.t;
      delete query.redirect;
      router.replace({ path: to.path, query: query });
      next();
    } else {
      next();
    }
  }

  store.commit('setWaiting', false);
  Vue.toasted.clear();
});

router.onError((err) => {
  if (err) {
    console.log(err);
  }
  router.push('/');
});

export default router;
